<template>
  <div class="card bg-white p-2 border border-solid rounded-lg min-w-0 m-0">
    <div v-if="title !== 'Total Partner Aktif'">
      <div class="flex flex-row items-center mb-2 gap-3">
        <span class="text-base md:text-md lg:text-lg">{{ title }}</span>
        <img
          v-b-tooltip.hover.top="{
            title: tooltipRegistrationData[title],
            customClass: 'dark-tooltip left-text-tooltip'
          }"
          src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
          alt="Info"
          class="w-[17px] h-[17px]"
        >
      </div>
      <BSpinner
        v-if="loading"
        small
        class="ml-1"
        variant="primary"
      />
      <div v-else>
        <span class="text-black text-xl md:text-2xl font-semibold my-1">
          {{ total }}
        </span>
        <div class="mt-2 md:mt-4">
          <slot name="children" />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-flex gap-4 mb-1">
        <img
          src="https://storage.googleapis.com/komerce/Komads/Icon.svg"
          alt="icon-komads"
        >
        <span class="text-base md:text-md lg:text-lg">Performance Overview</span>
      </div>
      <div class="d-flex">
        <div class="mr-1">
          <div class="flex flex-row items-center mb-2 gap-3">
            <span class="text-base md:text-md lg:text-lg">Total Registrasi</span>
            <img
              v-b-tooltip.hover.top="{
                title: 'Jumlah dari total registrasi user KomAds',
                customClass: 'dark-tooltip left-text-tooltip'
              }"
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="Info"
              class="w-[17px] h-[17px]"
            >
          </div>
          <BSpinner
            v-if="loading"
            small
            class="ml-1"
            variant="primary"
          />
          <div v-else>
            <div class="d-flex align-items-center gap-2">
              <span class="text-black text-xl md:text-2xl font-semibold">{{
                registrationData.total_register
              }}</span>
              <span
                :class="badgeClass"
                class="px-[10px] py-[4px] rounded rounded-pill"
              >{{ registrationData.percentage_registration || 0 }}%</span>
            </div>
            <div class="mt-2 md:mt-4">
              <span
                class="block text-base md:text-lg"
              >
                Bulan ini : {{ registrationData.total_register_current_month }}
              </span>
            </div>
          </div>
        </div>
        <div>
          <div class="flex flex-row items-center mb-2 gap-3">
            <span class="text-base md:text-md lg:text-lg">{{ title }}</span>
            <img
              v-b-tooltip.hover.top="{
                title: tooltipRegistrationData[title],
                customClass: 'dark-tooltip left-text-tooltip'
              }"
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="Info"
              class="w-[17px] h-[17px]"
            >
          </div>
          <BSpinner
            v-if="loading"
            small
            class="ml-1"
            variant="primary"
          />
          <div v-else>
            <span class="text-black text-xl md:text-2xl font-semibold my-1">
              {{ total }}
            </span>
            <div
              v-if="title !== 'Total Partner Aktif'"
              class="mt-2 md:mt-4"
            >
              <slot name="children" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
    description: {
      type: [String, Number],
      default: '',
    },
    registrationData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      IDR,
      tooltipRegistrationData: {
        'Total Partner Aktif': 'Total partner yang aktif sejak awal hingga akhir bulan yang dipilih',
        'Total Partner Whitelisted': 'Jumlah user KomAds yang telah mengaktifkan dan menggunakan layanan KomAds Whitelisted',
        'Akun Whitelisted': 'Jumlah dari total semua akun whitelisted dari semua user',
      },
    }
  },
  computed: {
    badgeClass() {
      return this.registrationData.user_info_data.some(item => item.percentage_registration > 0)
        ? 'increased-revenue'
        : 'decreased'
    },
  },
}
</script>

<style scoped>
.decreased {
  background-color: #FEF2F2;
  color: #FB2C36;
  width: fit-content;
}

.increased-revenue {
  background-color: #34a770;
  color: white;
  width: fit-content;
}
</style>
